import React from 'react';
import { useTheme } from '../../context/ThemeContext';
const ThemeToggle = ({ focused = false }) => {
    const { theme, toggleTheme } = useTheme();
    const darkModeActive = theme === 'dark';
    const destination = darkModeActive ? 'light' : 'dark';
    return (React.createElement("button", { type: "button", className: `wt-theme-toggle${focused ? ' wt-theme-toggle-focused' : ''}`, "aria-label": `Switch to ${destination} mode`, "aria-pressed": darkModeActive, title: `Switch to ${destination} mode`, onClick: toggleTheme },
        React.createElement("i", { className: `fa ${darkModeActive ? 'fa-sun-o' : 'fa-moon-o'}`, "aria-hidden": "true" }),
        React.createElement("span", { className: "wt-theme-toggle-label" }, darkModeActive ? 'Light' : 'Dark')));
};
export default ThemeToggle;
